import { inApp, callHandlerActionsButtons, isAndroid } from '@hst/utils';

// app内调用显示右上角三个点
export function toNativeActionsButtonsShare(shareObj = {}) {
	if (!inApp()) return;
	const params = {
		menu: {
			share: {
				...shareObj,
				...(isAndroid() ? { shareType: '' } : {}),
			},
		},
	};
	callHandlerActionsButtons(params);
}
